import Vue from 'vue'
import axios from 'axios'

export const testSpeed = (progressFunc,uploadSizeKb=512)=>{
   if(process.env.VUE_APP_CONNECTION_TEST==='false'){
     return new Promise((resolve => setTimeout(()=>resolve({upload:0.8, download:0.8}),2000)));
   }
   let uProg=0;
   let dProg=0;
   return Promise.all([
     testUpload((p)=>{
       uProg=p;
       progressFunc(Math.min(uProg,dProg));
     },uploadSizeKb),
     testDownload((p)=>{
       dProg=p;
       progressFunc(Math.min(uProg,dProg));
     })
   ]).then((result)=>{
     return {
       upload : result[0],
       download : result[1],
     }
   });
};

function testDownload(progress){
  const startTime = new Date();
  //const url='https://manage.fitt.ai/imgs/speedtest.jpg?rand='+Math.random();
  const url='/img/speedtest.jpg?rand='+Math.random();
  //const url='https://fitt-pub.s3-eu-west-1.amazonaws.com/speedtest.jpg?rand='+Math.random();
  let kbSize=1956.7890625;
  return axios.get(url,{
    onDownloadProgress:(progressEvent)=>{
      if(!kbSize){
        kbSize = progressEvent.total/1024;
      }
      progress(progressEvent.loaded / progressEvent.total);
    }
  }).then(()=>{
    const endTime = new Date();

    return getSpeed(kbSize,endTime - startTime);
  });
}

function testUpload(progress,kbSize=512){
  const blob = generateRandomBlob(kbSize);
  const startTime = new Date();

  let formData = new FormData();
  formData.append('file', blob, 'demo.jpg');

  return Vue.prototype.$http.post('/connection',formData,{
    headers:{
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent)=>progress(progressEvent.loaded / progressEvent.total)
  }).then(()=>{
    const endTime = new Date();
    return getSpeed(kbSize,endTime - startTime);
  });
}

function generateRandomBlob(kbSize) {
  return new Blob([new ArrayBuffer(kbToBytes(kbSize))], {type: 'application/octet-stream'});
}

function kbToBytes(kb){
  return kb * 1024;
}

function getSpeed(kbSize,msTime){
  const secs = msTime/1000;
  const kilobytePerSecond = kbSize/secs;
  return kilobytePerSecond/125;
}